import { Package } from "lucide-react";

interface OrderIndicatorProps {
  orderId: number;
  date?: string;
}

const OrderIndicator = ({ orderId, date }: OrderIndicatorProps) => {
  const dateStr = date
    ? new Date(date).toLocaleDateString([], { day: "2-digit", month: "short", year: "numeric" })
    : "";

  return (
    <div className="flex items-center gap-2 py-3 px-4">
      <div className="flex-1 h-px bg-gray-200" />
      <div className="flex items-center gap-1.5 px-3 py-1 bg-gray-100 rounded-full">
        <Package className="w-3 h-3 text-gray-500" />
        <span className="text-[11px] font-medium text-gray-500">
          Pedido #{orderId}
        </span>
        {dateStr && (
          <span className="text-[10px] text-gray-400">
            {dateStr}
          </span>
        )}
      </div>
      <div className="flex-1 h-px bg-gray-200" />
    </div>
  );
};

export default OrderIndicator;
